import { logError } from "@/revamp/utils";
import { request } from "@/revamp/utils";

async function getSortedCharitiesForUser(userId) {
  try {
    const response = await request(`${process.env.VUE_APP_FIREBASE_FUNCTIONS_URL}/getSortedCharitiesForUser`, "POST", { userId }, 'charityFunctions.getSortedCharitiesForUser', true);
    return response.data;
  } catch (e) {
    logError(`QRCodeFunctions.getSortedCharitiesForUser: Failed to get sorted charities for user ${userId}`);
    return null;
  }
}

async function listCharitiesQuickClaim(codeID, codeUrl) {
  try {
    let body = {};
    if (codeID) {
      body.codeDisplay = codeID;
    }
    if (codeUrl) {
      body.codeUrl = codeUrl;
    }

    const response = await request(`${process.env.VUE_APP_FIREBASE_FUNCTIONS_URL}/listCharitiesQuickClaim`, "POST", body, 'charityFunctions.listCharitiesQuickClaim', false);
    return response.data;
  } catch (e) {
    logError(`QRCodeFunctions.listCharitiesQuickClaim: Failed to list public charities`);
    return null;
  }
}

const charity_functions = {
  getSortedCharitiesForUser,
  listCharitiesQuickClaim
};

export default charity_functions;
